module.exports = __webpack_public_path__ + "static/img/kv.1477ab4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/kv.jpg
// module id = SeFX
// module chunks = 7